import React from 'react';
import Css from './Card.module.css';

export default function SkillCard(props) {

  return <div className={Css.Card} >
      <img className={Css.Img} src={props.item.img} alt="Project" />
      <div className={Css.heading}>{props.item.name}</div>
      <span className={Css.description}>{props.item.description}</span>

      <div className={Css.btnContainer}>
      <button className={Css.btn}><a className={Css.aTag} href={props.item.url} target="_blank" rel="noreferrer">CheckOut</a></button>
      </div>

    
  </div>;
}
